<template>
  <div class="homeWrap">
    <div class="pageBgSty">
      <div class="pageTitle">鑫安智能</div>
      <div class="pageTitleTips">智能物联和智慧环保领域国内领先的解决方案服务商</div>
    </div>
    <div class="contentWrap">
      <div class="con_title">解决方案</div>
      <div class="con_inner">
        <div class="tips_wrap">
          <div class="imgWrap"><img class="imgsty" src="./imgs/tips1.jpg" alt=""></div>
          <div class="tipsTitle">AI环保定制方案</div>
          <div class="tipsContent">
            <div class="tipsConTitle">AI硬件产品定制开发</div>
            <div class="tipsConTitle">AI软件产品定制开发</div>
            <div class="tipsConTitle">AI算法定制开发</div>
          </div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap"><img class="imgsty" src="./imgs/tips2.jpg" alt=""></div>
          <div class="tipsTitle">AI扬尘监测方案</div>
          <div class="tipsContent">
            <div class="tipsConTitle">扬尘指标监测</div>
            <div class="tipsConTitle">高清音视频监测</div>
            <div class="tipsConTitle">扬尘算法识别</div>
          </div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap"><img class="imgsty" src="./imgs/tips3.jpg" alt=""></div>
          <div class="tipsTitle">AI异味监测方案</div>
          <div class="tipsContent">
            <div class="tipsConTitle">异味指标监测</div>
            <div class="tipsConTitle">大气指纹分析溯源</div>
            <div class="tipsConTitle">异味算法识别</div>
          </div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap"><img class="imgsty" src="./imgs/tips4.jpg" alt=""></div>
          <div class="tipsTitle">空天地一体化监测方案</div>
          <div class="tipsContent">
            <div class="tipsConTitle">多模态全场景产品定制</div>
            <div class="tipsConTitle">多源数据接入</div>
            <div class="tipsConTitle">实时交互功能</div>
          </div>
        </div>
        <!--<div class="tips_wrap">
          <div class="imgWrap"><img class="imgsty" src="./imgs/tips5.jpg" alt=""></div>
          <div class="tipsTitle">温室气体监测方案</div>
          <div class="tipsContent">监测指标因子：CO₂、CH₄、H2O、N2O、CO、H2、 NH3等。
            产品支持固定式安装，车载式安装，便携式手提箱和无人机机载，可以快速精准的监测到温室气体。
          </div>
        </div>-->
      </div>
    </div>
<!--    <div class="split"></div>-->
    <div class="contentWrap">
      <div class="con_title">产品中心</div>
      <div class="con_inner">
        <div class="tips_wrap">
          <div class="imgWrap1"><img class="imgsty1" style="height: 200px;" src="./imgs/tc1.png" alt=""></div>
          <div class="tipsTitle">固定式</div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap1"><img class="imgsty1" style="height: 125px;" src="./imgs/tc2.png" alt=""></div>
          <div class="tipsTitle">车载式</div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap1"><img class="imgsty1" style="height: 200px;" src="./imgs/tc3.png" alt=""></div>
          <div class="tipsTitle">便携式</div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap1"><img class="imgsty1" src="./imgs/tc4.png" alt=""></div>
          <div class="tipsTitle">无人机机载式</div>
        </div>
        <div class="tips_wrap">
          <div class="imgWrap1"><img class="imgsty1" src="./imgs/tc5.png" alt=""></div>
          <div class="tipsTitle">信息化软件</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{

      }
    },

    created(){

    },
    components: {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .homeWrap
    width 100%
    .pageBgSty
      width 100%
      height 550px
      background url("~@/assets/imgs/page_bg_home.jpg") no-repeat
      background-size 100% 100%
      display flex
      align-items center
      justify-content center
      flex-direction column
      color white
      .pageTitle
        font-size 30px
        letter-spacing 3px
        margin-bottom 15px
      .pageTitleTips
        letter-spacing 2px
        font-size 20px
        margin-bottom 150px
    .contentWrap
      width 1200px
      margin 0 auto
      padding 60px 0 50px 0
      .con_title
        font-size 22px
        color #333333
        font-weight bold
        text-align center
        position relative
        padding-bottom 20px
        margin-bottom 25px
        &:after
          content: "";
          position absolute
          left 50%
          bottom 0
          margin-left -15px
          width 30px
          height 3px
          background-color #3E85F1
      .con_inner
        width 100%
        display flex
        .tips_wrap
          flex 1
          margin 0 10px
          .tipsContent
            line-height 25px
            color #666
            font-size 14px
            border 1px solid #ccc
            height 75%
            width 100%
            padding 10px
            box-sizing border-box
            border-radius 10px
            .tipsConTitle
              color #333
              font-weight bold
          .tipsTitle
            text-align center
            font-weight bold
            font-size 18px
            margin 15px 0
          .imgWrap
            text-align center
            .imgsty
              height 60px
              margin-top 15px
          .imgWrap1
            height 200px
            display flex
            align-items center
            justify-content center
            .imgsty1
              height 170px
              margin 15px 0
        .tips_img
          width 100%
          height 100%
    .split
      background: #F1F1F1;
      height 15px
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue